import cx from "classnames";
import React, { useEffect, useState } from "react";

import { Container, getFetchGetOptions, simpleAxiosUrlFetch } from "@gamedev-web/gamedev-sdk-core";

import * as commonStyles from "../../../components/commonStyles/commonStyles.module.css";
import { LoadingSpinner } from "../../../components/Spinner";
import { siteLocationPrefix } from "../../../constants";
import { getImage, ImageType } from "../../../helpers/imageHelper";
import {
  EmailVerifySubtitle,
  ErrorStepDefaultSubtitle,
  StreamingEuStepTitle,
} from "../streamingEuContent";
import * as styles from "../StreamingEuPage.module.css";
import { StreamingEuCloseButton } from "./StreamingEuCloseButton";

const verifyCrmDataUrl = `${siteLocationPrefix}/streamingEu/verify`;

export const EmailVerify = () => {
  const [isDataStored, setIsDataStored] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    if (!id) {
      setIsError(true);
      return;
    }

    if (!isDataStored) {
      const saveData = async () => {
        let response = null;
        try {
          response = await simpleAxiosUrlFetch(getFetchGetOptions(`${verifyCrmDataUrl}?id=${id}`));
        } catch (e) {
          setIsError(true);
        }

        if (response?.status === 200) {
          setIsDataStored(true);
        } else {
          setIsError(true);
        }
      };
      saveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isError) {
    return (
      <>
        <h1 className={styles.title}>{StreamingEuStepTitle.Error}</h1>
        <p>{ErrorStepDefaultSubtitle}</p>
        <div className={styles.horizontalCentering}>
          <StreamingEuCloseButton isPrimary={true} />
        </div>
      </>
    );
  }

  if (!isDataStored) {
    return (
      <Container className={cx(commonStyles.spinnerContainer, styles.spinnerBackground)}>
        <LoadingSpinner />
      </Container>
    );
  }

  return (
    <>
      <h1 className={styles.title}>{StreamingEuStepTitle.EmailVerify}</h1>
      <p>{EmailVerifySubtitle}</p>
      <div className={styles.horizontalCentering}>
        <img
          src={getImage("streaming-eu-thankyou-image", ImageType.Png)}
          alt={StreamingEuStepTitle.ThankYou}
        />
      </div>
      <div className={styles.horizontalCentering}>
        <StreamingEuCloseButton isPrimary={true} />
      </div>
    </>
  );
};
